





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserGoal, { MilestoneExam } from '../../../api/v2/models/user_goal';
import UserGoalUserExam from '../atoms_molecules/UserGoalUserExam.vue'
import { ROUTER_NAME } from '../../router';

@Component({
  components: {
    UserGoalUserExam
  }
})
export default class UserGoalSuggestion extends Vue {

  @Prop({ required: true })
  userGoal: UserGoal
  
  get latestJoinedExam() {
    return this.userGoal.latestJoinedExams[0]
  }
  
  gotoExamResult(exam: MilestoneExam){
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: `${exam.id}`
      },
      query: {
        user_exam_id: `${exam.userExam.id}`
      }
    })
  }

  gotoExams(){
    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }
}
